export enum DialogsActionTypes {
  CLOSE_DIALOG = "@dialogs/closeDialog",
  SHOW_DIALOG = "@dialogs/showDialog"
}

export interface IConfirmDialogsState {
  show: boolean;
  messageId: string;
  values: {};
  confirmCallback?: () => void;
  cancelCallback?: () => void;
}

export interface IErrorDialogsState {
  show: boolean;
  messageId: string;
  values: {};
}

export interface ISuccessDialogsState {
  show: boolean;
  messageId: string;
  values: {};
}

export interface IDialogsState {
  confirmDialog: IConfirmDialogsState;
  errorDialog: IErrorDialogsState;
  successDialog: ISuccessDialogsState;
}

export interface IShowDialog {
  type: DialogsActionTypes;
  payload: {
    message: string;
    values: {};
    dialogName: string;
    confirmCallback: () => void;
    cancelCallback: () => void;
  };
}

export type IDialogsAction = ISuccessDialogsState & IErrorDialogsState & IConfirmDialogsState;

export type DialogsActions = IShowDialog;
